const set = require('regenerate')();
set.addRange(0x0, 0x7F);
exports.characters = set;
